import { Button, Dialog, Modal, withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { useTranslation } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import { Input } from 'client/common/form-inputs';
import translations from 'src/internationalisation/translation-map.json';
import { useForm } from 'react-hook-form';
import { getResolver } from 'src/validation/resolver';
import { IPriceBook } from 'src/common/interfaces/price-book.interfaces';
import { updatePriceBook } from 'src/store/entities/price-book/price-book';
import { priceBookSchemaValidator } from 'schemas/ajv-validators';

import { useParams } from 'react-router';

type TPriceBookRenameModalProps = PropsFromRedux & {
  selectedPriceBook: IPriceBook;
  onClickRenamePriceBook: (data: IPriceBook | null) => void;
};

const PriceBookRenameModal = ({
  selectedPriceBook,
  onClickRenamePriceBook,
  updatePriceBook,
}: TPriceBookRenameModalProps) => {
  const { t } = useTranslation();

  const { company: companyId } = useParams();
  const { name, priceBookId, subjectId } = selectedPriceBook;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name,
      priceBookId,
    },
    resolver: getResolver(priceBookSchemaValidator),
    mode: 'onChange',
  });

  const onClose = () => onClickRenamePriceBook(null);

  const onSubmit = handleSubmit((data) => {
    updatePriceBook({ ...data, companyId, subjectId });
    onClose();
  });

  return (
    <Modal centered visible>
      <Dialog
        dialog={{
          heading: t(translations.renameCategory),
          content: (
            <form>
              <Input name="name" width={300} control={control} errors={errors} />
            </form>
          ),
          footer: (
            <>
              <Button label={t(translations.rename)} colored onClick={onSubmit} />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const mapDispatchToProps = { updatePriceBook };

const connector = connect(null, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Container = withErrorBoundary(connector(PriceBookRenameModal), {
  style: { position: 'absolute', bottom: 0, zIndex: 1000 },
});

export { Container as PriceBookRenameModal };
